export const contentOfConfirmationCard: {
    [key: string]: {
        lottie?: string;
        image?: string;
        title?: string;
        description?: string;
        confirmButtonName?: string;
        cancelButtonName?: string;
        isButtonShow?: boolean;
        buttonDirection?: string;
        html?: boolean;
        hideCloseBtn?: boolean;
    };
} = {
    confirm_logout: {
        image: "assets/svg/icons/logout-gb.svg",
        title: "Are you sure you want to log out?",
        confirmButtonName: "Log Out",
        cancelButtonName: "Cancel",
        hideCloseBtn: true,
    },
    net_banking_exit: {
        lottie: "info",
        title: "Are you sure you want to exit?",
        description: "Your progress will not be saved if you leave now",
        confirmButtonName: "Exit",
        cancelButtonName: "Stay",
        isButtonShow: true,
        buttonDirection: "direction-row",
    },
};

export const TimelineEvent: string[] = [
    "NETBANKING_FAILED",
    "NP_ANALYSIS_COMPLETED",
    "NB_ANALYSIS_VERIFIED",
    "NETBANKING_IN_ANALYSIS",
    "WORK_EMAIL_AUTO_VERIFY",
    "NETBANKING_COMPLETED",
    "PAN_KYC_VERIFIED",
    "BANK_ACCOUNT_VERIFIED",
    "BANK_ACCOUNT_VERIFICATION_INPROGRESS",
    "LOAN_APPLICATION_DECLINED",
    "LOAN_DISBURSEMENT_STATUS",
    "WORK_EMAIL",
    "FINAL_VERIFICATION_VERIFIED",
    "LOAN_STEP_CHANGE",
    "DISBURSEMENT_FAILED",
    "DISBURSEMENT_QUEUED",
    "NB_ANALYSIS_AUTO_DECLINED",
    "NB_ANALYSIS_AUTO_APPROVED",
    "CKYC_SKIP",
    "BANK_ACCOUNT_VERIFICATION_MANUAL",
];

export const DashboardEvent: string[] = [
    "PROFILE_RETAKE",
    "PROFILE_REVOKE",
    "PROFILE_RETAKE_VERIFIED",
    "CUSTOMER_BLACKLISTED",
    "CUSTOMER_COOLOFF",
    "CUSTOMER_ACTIVATED",
    "CUSTOMER_DELETED",
    "CUSTOMER_NOT_ALLOW_LOAN_APPLY",
    "CUSTOMER_ALLOW_LOAN_APPLY",
    "LOAN_PAYMENT_STATUS",
    "AADHAR_KYC_EXPIRED_BY_ADMIN",
    "AADHAR_KYC_ALIVE_BY_ADMIN",
    "PAN_KYC_EXPIRED_BY_ADMIN",
    "PAN_KYC_ALIVE_BY_ADMIN",
    "LOAN_IMPS_CREATE_SUCCESS",
];

export const screenContent: {
    [key: string]: {
        icon?: string;
        title?: string;
        description?: string;
        lottie?: string;
        buttonName?: string;
        secondButtonName?: string;
        retryAfterTitle?: string;
        retryAfter?: number;
        rightButtonRoute?: string;
        rightButtonName?: string;
        leftButtonRoute?: string;
        rightButtonIcon?: string;
    };
} = {
    ServerDown: {
        icon: "assets/svg/icons/eye-gs.svg",
        title: "Server Down",
        description: "Our servers are currently down due to a technical issue. We’re actively fixing it.",
        rightButtonRoute: "reload",
        rightButtonName: "Refresh",
        rightButtonIcon: "assets/svg/icons/retry.svg",
    },
    ServerError: {
        icon: "assets/svg/icons/eye-gs.svg",
        title: "Something went wrong!",
        description: "There seems to be a connection issue. Please try again.",
        rightButtonRoute: "reload",
        rightButtonName: "Retry",
        rightButtonIcon: "assets/svg/icons/retry.svg",
    },
    NoInternet: {
        icon: "assets/svg/icons/no-internet-gbs.svg",
        title: "No internet connection",
        description: "Your device seems modified, so some features may not work as expected.",
        rightButtonRoute: "reload",
        rightButtonName: "Refresh",
        rightButtonIcon: "assets/svg/icons/retry.svg",
    },
    LocationPermission: {
        icon: "assets/svg/icons/eye-gs.svg",
        title: "Location Permission",
        description: "Please allow us to access your location permission.",
        rightButtonRoute: "reload",
        rightButtonName: "Try Again",
    },
};

export const dialogContent: {
    [key: string]: {
        image?: string;
        title?: string;
        description?: string;
        lottie?: string;
        buttonName?: string;
        isButtonShow?: boolean;
    };
} = {
    LoanInProgressForDeleteAccount: {
        image: "assets/svg/icons/information-circle.svg",
        title: "Your account cannot be deleted as some actions on your account are still in progress.",
        buttonName: "Okay",
    },
    AccountDelete: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Your account has been successfully deleted.",
        buttonName: "Done",
    },
    LoanInProgressForClearSensitiveData: {
        image: "assets/svg/icons/information-circle.svg",
        title: "Your sensitive data cannot be cleared at this time as some actions are still in progress on your account.",
        buttonName: "Okay",
    },
    SensitiveDataSuccess: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Your sensitive data has been cleared successfully.",
        buttonName: "Done",
    },
    UserDecline: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Thank you. Your loan application has been successfully declined.",
        buttonName: "Okay",
    },
    NickNameUpdated: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Nickname has been updated successfully",
        buttonName: "Done",
    },
    MaritalStatusUpdated: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Marital status has been updated successfully",
        buttonName: "Done",
    },
    LinkedInIdSuccess: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "LinkedIn Id has been successfully updated",
        buttonName: "Done",
    },
    EmploymentStatusUpdated: {
        image: "assets/svg/icons/badge-success-gb.svg",
        title: "Employment status has been updated successfully",
        buttonName: "Done",
    },
    CatchError: {
        image: "assets/svg/icons/information-circle.svg",
        title: "For help, please contact our support team at customer.support@klinq.in or call us on {{support number}}",
        buttonName: "Try Again",
    },
    AlreadyOpenQuery: {
        image: "assets/svg/icons/information-circle.svg",
        title: "You already have a request in progress, so a new request cannot be created at the moment.",
        buttonName: "Okay",
    },
};
